import * as React from "react";
import { CustomFieldInput } from "./CustomFieldInput";
export function CustomFieldsInput(props) {
    // var group = useFormGroup(props);
    return React.createElement(React.Fragment, null, props.fields.map((field, idx) => React.createElement(CustomFieldInput, Object.assign({}, props, { key: field.name, field: field }))));
}
//# sourceMappingURL=CustomFieldsInput.js.map